module.exports = __webpack_public_path__ + "static/media/file-button.b277c9c7.svg";